import { cn } from "~/utils/fontsConfig";
import Image from "next/image";
import { env } from "~/env.mjs";
import { Avatar, AvatarImage } from "./Avatar";
import { CustomizableLayout } from "~/types/CustomizableLayout";

export const UserAvatar = ({
    user,
    className,
    height = 40,
    width = 40,
    size = 10,
    customization,
}: {
    user: {
        name?: string | null;
        email?: string | null;
        image?: string | null;
    };
    className?: string;
    height?: number;
    width?: number;
    size?: number;
    customization?: CustomizableLayout;
}) => {
    const initial = user?.name
        ? user.name
              ?.split(" ")
              .slice(0, 1)
              .map((word) => word.charAt(0).toUpperCase())
              .join("")
        : user?.email
              ?.split(" ")
              .slice(0, 1)
              .map((word) => word.charAt(0).toUpperCase())
              .join("");

    const getBgColorAndChar = (initial: string) => {
        if (!initial) return { image: "", textClass: "" };

        const char = initial.toUpperCase();
        const charCode = char.charCodeAt(0);

        const defaultPfps = Array.from(
            { length: 8 },
            (_, i) => `profile_${i + 1}.svg`,
        );

        const index = charCode - 65;
        return defaultPfps[index % defaultPfps.length]!;
    };

    const defaultImage = initial ? getBgColorAndChar(initial) : "profile_1.svg";

    return (
        <>
            {user?.image ? (
                <Avatar
                    className={cn(
                        `h-${size} w-${size}`,
                        className,
                        customization?.className,
                    )}
                >
                    <AvatarImage src={user.image} />
                </Avatar>
            ) : (
                <div
                    className={cn(
                        `h-${size} w-${size}`,
                        "relative flex items-center justify-center rounded-full",
                        className,
                        customization?.className,
                    )}
                >
                    <Image
                        src={`${env.NEXT_PUBLIC_ASSETS_URL}/profile/default/${defaultImage}`}
                        alt="User avatar"
                        height={height}
                        width={width}
                        className={cn(
                            "absolute rounded-full object-cover",
                            className,
                        )}
                    />
                    <span
                        className={cn("text-md relative mix-blend-difference")}
                    >
                        {initial ?? "U"}
                    </span>
                </div>
            )}
        </>
    );
};
